import axios from 'axios';
import powerBISettings from '../configs/powerBISettings.js';

const reportServiceUrl = powerBISettings.reportServiceUrl;
const tenantAdminServiceUrl = powerBISettings.tenantAdminServiceUrl;
const flareDocumentUrl = powerBISettings.flareDocumentUrl;

export function getProductFeatureList() {
  return axios.get(`${reportServiceUrl}usermodules`);
}

export function getHVAObjectList(tenantId) {
  return axios.get(`${tenantAdminServiceUrl}HVAObjectType/HVAObjectTypes/${tenantId}`);
}

export function getHVAObjectListForUser(tenantId, userId) {
  return axios.get(`${tenantAdminServiceUrl}HVAObjectType/HVAObjectTypes/${tenantId}/user/${userId}`);
}

export function saveAsReport(data) {
  return axios.post(`${reportServiceUrl}saveasreport`, data);
}

export function openFlareDocument(tableDetails) {
  if (flareDocumentUrl.toLowerCase() === '{flaredocumenturl}') {
    alert('Support Documentation is not configured. Please contact Lumedx Administrator.');
    return;
  }
  try {
    return axios.post(flareDocumentUrl, JSON.stringify(tableDetails));
  } catch (e) {
    alert(e);
  }
}

export function getReportAccessToken(featureId, rls, tenantId, powerBIaccessToken) {
  return axios.get(`${reportServiceUrl}accesstoken/${featureId}/rls/${rls}/${tenantId}`, {
    headers: { PowerBIaccessToken: powerBIaccessToken }
  });
}

export function getTenantAdminUIURL() {
  return axios.get(`${tenantAdminServiceUrl}tenantadmin/url`);
}

export function getTenantAdminLinkCaption() {
  return axios.get(`${tenantAdminServiceUrl}tenantadmin/urlcaption`);
}

export function isServiceAdmin() {
  return axios.get(`${tenantAdminServiceUrl}user/isserviceadmin`);
}

export function isTenantAdmin() {
  return axios.get(`${tenantAdminServiceUrl}user/istenantadmin`);
}

export function getAllUsersByTenantId(tenantId, includeRoleInfo = false) {
  return axios.get(`${tenantAdminServiceUrl}tenant/current/users?tenantId=${tenantId}&includeRoleInfo=${includeRoleInfo}`);
}

export function getAllUsers(tenantId, includeRoleInfo = false) {
  return axios.get(`${tenantAdminServiceUrl}user/allusers?tenantId=${tenantId}&includeRoleInfo=${includeRoleInfo}`);
}

export function getProductFeatureListByUPN(upn) {
  return axios.get(`${tenantAdminServiceUrl}producthvaobject/upn?upn=${encodeURI(upn)}`);
}

export function getProductFeatureListByTenant(tenantId) {
  return axios.get(`${tenantAdminServiceUrl}producthvaobjectfortenant/${tenantId}`);
}

export function getConfig(tenantId, groupName, keyName) {
  return axios.get(`${tenantAdminServiceUrl}config/tenantId/${tenantId}/groupName/${groupName}/key/${keyName}`);
}

export function getUserType() {
  return axios.get(`${tenantAdminServiceUrl}user/usertype`);
}

export function getUserTypeAsParameter() {
  // This function would need to be handled with React state/context
  // Placeholder implementation
  return null;
}

export function setUserTypeAsParameter(val, tenantAdminCaption, tenantAdminURL) {
  // This function would need to be handled with React state/context
  // Placeholder implementation
}

export function getHVAUserObjectsForUserAndRoles() {
  return axios.get(`${tenantAdminServiceUrl}user/gethvauserobjectsforuserandroles`);
}

export function getHVAObjectTypeList(tenantId, objectType) {
  return axios.get(`${tenantAdminServiceUrl}HVAObjectType/tenant/${tenantId}/${objectType}`);
}

export function getUserByUPN() {
  return axios.get(`${tenantAdminServiceUrl}user/gethvauserbyupn`);
}

export function getHVAUserTenantAccessMappings(userId) {
  return axios.get(`${tenantAdminServiceUrl}user/getusertenantaccessmappings/${userId}`);
}

export function getCustomerTenants(includeProperties = false) {
  return axios.get(`${tenantAdminServiceUrl}tenant/customers?includeFullHierarchy=${includeProperties}`);
}

export function addOrUpdateUserNotfications(showMessageAgain, notifications) {
  return axios.post(`${tenantAdminServiceUrl}notification/updateUserNotification/${showMessageAgain}`, JSON.stringify(notifications));
}

export function refreshContentPack(tenantId, objectId) {
  return axios.post(`${reportServiceUrl}refreshcontentpack?tenantid=${tenantId}&objectId=${objectId}`);
}

export function getLastRefreshDate(tenantId, objectId) {
  return axios.get(`${reportServiceUrl}lastRefreshDate/${tenantId}/${objectId}`);
}

export function getAllCapacity() {
  return axios.get(`${tenantAdminServiceUrl}powerbicapacity`);
}

export function getPowerBIAccessToken(tenantId) {
  return axios.get(`${reportServiceUrl}powerbiaccesstoken/tenantid/${tenantId}`);
}

export function getPlatformTenant() {
  return axios.get(`${tenantAdminServiceUrl}tenant/platform`);
}

export function getTenantById(tenantId, includeProperties = false) {
  const includeFullHierarchy = includeProperties ? includeProperties : false;
  return axios.get(
    `${tenantAdminServiceUrl}tenant/${tenantId}?includeFullHierarchy=${includeFullHierarchy}`
  );
}

export function generateTokenForReport(accessToken, reportId, workSpaceId, data) {
  const endpoint = `https://api.powerbi.com/v1.0/myorg/groups/${workSpaceId}/reports/${reportId}/GenerateToken`;
  return axios.post(endpoint, data, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json; charset=utf-8',
    },
  });
}

export function getEmbeddedURLForReport(accessToken, reportId, workSpaceId) {
  const endpoint = `https://api.powerbi.com/v1.0/myorg/groups/${workSpaceId}/reports/${reportId}`;
  return axios.get(endpoint, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json; charset=utf-8',
    },
  });
}

export function getReportLastRefreshInfo(accessToken, datasetId) {
  const endpoint = `https://api.powerbi.com/v1.0/myorg/datasets/${datasetId}/refreshes?$top=1`;
  return axios.get(endpoint, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json; charset=utf-8',
    },
  });
}

export function AddOrUpdateUserNotifications(dontShowMessageAgain, notifications) {
  const notificationsData = JSON.stringify(notifications);

  return axios.post(
    `${tenantAdminServiceUrl}notification/updateUserNotification/${dontShowMessageAgain}`,
    notificationsData,
    {
      headers: {
        "Content-Type": "application/json; charset=utf-8,",
      },
    }
  );
}

export function validateConcurrentSession() {
  return axios.get(`${tenantAdminServiceUrl}loginprerequisite/validate`);
}